import React, {useEffect, useState} from 'react';
import "@assets/scss/react/pages/login/main.scss";
import loginPic from "@assets/images/pages/login/loginPic.png";
import {animated} from 'react-spring';
import {use3dEffect} from 'use-3d-effect';
import {AvField, AvForm} from 'availity-reactstrap-validation';
import {NavLink, useNavigate} from "react-router-dom";
import {PostRequest} from "../../../configs/request";
import ObjectToFormData from "../../../configs/utils/ObjectToFormData";
import {useDispatch, useSelector} from "react-redux";
import {handleLogin} from "../../../redux/actions/auth";
import {Spinner} from "reactstrap";

const Login = (props) => {
    const url = "/authentication/authenticate";
    const ref = React.useRef(null);
    const {style, ...mouseHandlers} = use3dEffect(ref);
    const [user, setUser] = useState("");
    const [pass, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const LoginUser = useSelector(state => state.auth);
    const navigate = useNavigate();

    const handleSubmit = (event, values) => {
        setLoading(true);
        PostRequest(url, ObjectToFormData({
            login: user, password: pass
        })).then((response) => {
            if (response) {
                let result = response.data;
                if (result.ok && result.data) {
                    result = result.data;
                    dispatch(handleLogin(result));
                }
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (LoginUser.token)
            navigate('/panel/admin/articles')
    }, [LoginUser])

    return (
        <div className="login-page">
            <div className="limiter">
                <div className="container-login100 ">
                    <div className="wrap-login100">
                        <animated.div
                            ref={ref}
                            style={style}
                            {...mouseHandlers}>
                            <div className="login100-pic">
                                <img src={loginPic} alt="IMG"/>
                            </div>
                        </animated.div>
                        <AvForm className="login100-form validate-form" onValidSubmit={handleSubmit}>
                            <span className="login100-form-title">
                                ورود به پنل
                            </span>
                            <div className="wrap-input100 validate-input mb-2">
                                <AvField
                                    className="input100"
                                    type="text"
                                    name="username"
                                    placeholder="نام کاربری"
                                    onChange={(e) => setUser(e.target.value)}
                                    validate={{
                                        required: {
                                            value: true,
                                            errorMessage: 'لطفا نام کاربری را وارد نمایید',
                                        },
                                    }}
                                />
                                <span className="focus-input100"></span>
                                <span className="symbol-input100">
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div className="wrap-input100 validate-input">
                                <AvField
                                    className="input100"
                                    type="password"
                                    name="pass"
                                    placeholder="رمز عبور"
                                    onChange={(e) => setPassword(e.target.value)}
                                    validate={{
                                        required: {
                                            value: true,
                                            errorMessage: 'لطفا رمز عبور را وارد نمایید',
                                        },
                                    }}
                                />
                                <span className="focus-input100"></span>
                                <span className="symbol-input100">
                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div className="container-login100-form-btn">
                                <button className="login100-form-btn" disabled={loading}>
                                    {loading ?
                                        <div className="box-spinner">
                                            <Spinner color="primary" className="reload-spinner"/>
                                        </div>
                                        :
                                        "ورود"
                                    }

                                </button>
                            </div>
                        </AvForm>
                        <NavLink to="/" className="home-page">
                            <span className="ml-1">
                                صفحه اصلی
                            </span>
                            <i className="fa fa-home"/>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
